/**
 * Normalize a raw Stripe `selectedPlan` value into the product bucket
 * used by Statsig events. Suffix mirrors the raw Stripe lookup key
 * (snake_cased) so the Statsig value is traceable back to the SKU.
 *
 * Brand identification happens via the `brand` field on the event /
 * user properties, not via the value name. See TAXONOMY.md.
 *
 * Keep in sync with the `productNormalizedSchema` enum in `@repo/statsig`.
 */
export type NormalizedProduct =
  | "unlimited_rx"
  | "pediatric_support"
  | "pediatric_support_single"
  | "pediatric_support_family"
  | "other";

export function normalizeProductKey(plan: string | null | undefined): NormalizedProduct {
  if (plan === "unlimitedRx" || plan === "kinsaClinic") return "unlimited_rx";
  if (plan === "pediatricSupport") return "pediatric_support";
  if (plan === "pediatricSupportSingle") return "pediatric_support_single";
  if (plan === "pediatricSupportFamily") return "pediatric_support_family";
  return "other";
}
